// extracted by mini-css-extract-plugin
module.exports = {"danger":"Code_danger__ILwpd"};